import { Component, EventEmitter, OnDestroy, OnInit, Output  } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tenants',
  templateUrl: './tenants.component.html',
  styleUrl: './tenants.component.css'
})
export class TenantsComponent implements OnInit, OnDestroy {
  @Output() dataChange = new EventEmitter();

  loadingFlag = true;
  inkBarPosition: string = '0%';
  constructor(
    private router: Router,
  ) {  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {

  }


  onActivate(elementRef: any) {
  }
}
